import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"segmentWrapper":"styles_segmentWrapper__9H-vK","segment":"styles_segment__UfpgZ","calendarButton":"styles_calendarButton__NAOiP","hiddenInput":"styles_hiddenInput__IfCmM"};
export const b = b_.with('segmentWrapper');